import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = (_, { palette = {} }) => ({
  container: {
    // palette.mode indicate it's in preview
    backgroundColor: palette.mode ? palette.buttonBackground : '#323130',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  label: {
    fontSize: 18,
    lineHeight: '20px',
    fontWeight: 'bold',
    color: palette.mode ? palette.buttonText : '#ffffff',
  },
});

const getFirstLetterCapitalized = (word) => {
  if (!word) return '';

  return word[0].toUpperCase();
};

export const UnStyledCircleLogo = ({
  classes,
  name,
  className,
}) => {
  const words = name && name.trim().split(/\s+/);
  const nameInCircle = `${words && getFirstLetterCapitalized(words[0])}${words && getFirstLetterCapitalized(words[1])}`;

  return (
    <div className={classnames(classes.container, className)}>
      <span className={classes.label} >{nameInCircle}</span>
    </div>);
};

UnStyledCircleLogo.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export const CircleLogo = withDefaultStyles(
  UnStyledCircleLogo,
  getStyles
);
